import React from 'react';
import ProductItem from '../ProductItem/ProductItem';

const RelatedProduct = (props) => {
  const data = props;
  return (
    <>
      <h3
        className="text-center mb-4"
        style={{
          borderBottom: 'solid',
          lineHeight: '2',
        }}
      >
        関連商品
      </h3>
      <div className="single-list row">
        {
            data.productList.length > 0
              ? (
                data.productList.map((item) => (
                  <ProductItem
                    key={item.id}
                    id={item.id}
                    imgUrl={item.main_image}
                    name={item.name}
                    price={item.price}
                    isSubscription={item.product_categories[0]?.category_name === '定期便'}
                    page={data.page}
                    label
                  />
                ))
              ) : ''
            }
      </div>
    </>
  );
};

export default RelatedProduct;
